// extracted by mini-css-extract-plugin
export var deliveryRow = "_sg-a";
export var fixedHeight = "_sg-4";
export var freightLogo = "_sg-9";
export var fullWidth = "_sg-3";
export var priceColumn = "_sg-5";
export var radioSelected = "_sg-7";
export var radioUnselected = "_sg-6";
export var selectedOption = "_sg-2";
export var selectedOptionContainer = "_sg-1";
export var selection = "_sg-0";
export var tallSkeletonText = "_sg-8";